/* eslint-disable no-sequences */
/* eslint-disable react/no-array-index-key */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OfferingModel {
    fields: {
        image: string;
        expertName: string;
        expertExperience: string;
        linkTitle: string;
        linkURL: LinkFieldValue;
        expertTime: string;
    };
}

const enum fields {
    title = "title",
    description = "description",
    changeImage = "changeImage",
    startDate = "startDate",
    offerings = "offerings",
    contactNumber = "contactNumber",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.description]: string;
        [fields.changeImage]: string;
        [fields.startDate]: string;
        [fields.contactNumber]: number;
        [fields.offerings]: OfferingModel[];
    };
}

export interface LookingExpertPDPStyles {
    container?: InjectableCss;
    titleGridItem?: InjectableCss;
    imageGridItem?: InjectableCss;
    imageAndTitleSection?: InjectableCss;
    titileDescriptionGridItem?: InjectableCss;
    scheduleLinkStyle?: InjectableCss;
    expertTitle?: TypographyPresentationProps;
    expertExperience?: TypographyPresentationProps;
    expertTime?: TypographyPresentationProps;
    image?: LazyImageProps;
    chatButtonWrapper?: InjectableCss;
    numberStyles?: InjectableCss;
}

export const lookingExpertPDPStyles: LookingExpertPDPStyles = {
    container: {
        css: css`
            padding: 32px;
            /* background: ${COLORS.background.grayShade}; */
            background-color: #e0dfe0;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
        `,
    },
    titleGridItem: {
        css: css`
            display: flex;
            flex-direction: column;
            color: ${getProp("theme.typography.p.color")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 9px;
                    `,
                    css`
                        margin-bottom: 9px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    titileDescriptionGridItem: {
        css: css`
            flex-direction: column;
        `,
    },
    imageAndTitleSection: {
        css: css`
            display: flex;
            align-items: flex-start;
            flex-wrap: nowrap;
            justify-content: start;
            gap: 16px;
        `,
    },
    expertTitle: {
        css: css`
            color: ${getProp("theme.typography.h5.color")};
            font-size: ${TYPOGRAPHY.size.largest};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 32px;
            margin-bottom: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: ${TYPOGRAPHY.size.large};
                            line-height: 24px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )};
        `,
    },

    expertExperience: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 16px;
            margin-bottom: 12px;
        `,
    },
    expertTime: {
        css: css`
            font-size: ${TYPOGRAPHY.size.tiny};
            font-weight: ${TYPOGRAPHY.weight.base};
            line-height: 16px;
        `,
    },
    chatButtonWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 8px;
        `,
    },
    scheduleLinkStyle: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 16px;
            border: 2px solid ${COLORS.secondary.base};
            border-radius: 24px;
            padding: 8px 12px;
            height: 32px;
            color: ${COLORS.secondary.base} !important;

            span {
                color: ${COLORS.secondary.base} !important;
            }
        `,
    },
    image: {
        css: css`
            aspect-ratio: 1/1;
            object-fit: contain;
            max-width: 72px;
            max-height: 72px;
            height: auto;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            max-height: 72px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    numberStyles: {
        css: css`
            color: ${getColor("text.link")};
        `,
    },
};

const mapStateToProps: any = (state: ApplicationState, ownProps: OwnProps) => {
    return {
        pageLink: ownProps.fields.offerings.map(card => getLink(state, card.fields.linkURL)),
    };
};

const mapDispatchToProps = {};
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const styles = lookingExpertPDPStyles;
const CenCategoryLookingForExpert: React.FC<Props> = ({ fields, pageLink }) => {
    const [chatLink, setChatLink] = useState<any>();
    const [offerringsUpdate, setOfferingData] = useState<any>();
    useEffect(() => {
        const changeImageDaysNumber = Number(fields.changeImage);
        const selectedStartDate = new Date(fields.startDate);
        const todayDate = new Date();

        if (todayDate >= selectedStartDate) {
            const offeringsArrLen = fields.offerings.length;
            const diffDays =
                Math.floor(
                    (Date.UTC(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate()) -
                        Date.UTC(
                            selectedStartDate.getFullYear(),
                            selectedStartDate.getMonth(),
                            selectedStartDate.getDate(),
                        )) /
                        (1000 * 60 * 60 * 24),
                ) / changeImageDaysNumber;
            const diffDaysRound = Math.ceil(diffDays);

            if (offeringsArrLen > diffDaysRound) {
                setOfferingData(fields.offerings[diffDaysRound]);
                setChatLink(pageLink[diffDaysRound]?.url);
            } else if (offeringsArrLen < diffDaysRound) {
                const expertLengthDiff = diffDaysRound % offeringsArrLen;
                setOfferingData(fields.offerings[expertLengthDiff]), setChatLink(pageLink[expertLengthDiff]?.url);
            } else if (offeringsArrLen === diffDaysRound) {
                setOfferingData(fields.offerings[offeringsArrLen - 1]);
                setChatLink(pageLink[offeringsArrLen - 1]?.url);
            }
        }
    }, [fields]);

    return (
        <>
            {offerringsUpdate && (
                <StyledWrapper {...styles.container}>
                    <StyledWrapper {...styles.titileDescriptionGridItem}>
                        {fields.title && (
                            <Typography as="h5" {...styles.expertTitle}>
                                {fields.title}
                            </Typography>
                        )}
                    </StyledWrapper>

                    <StyledWrapper>
                        <StyledWrapper {...styles.imageAndTitleSection}>
                            <StyledWrapper {...styles.imageGridItem}>
                                <LazyImage {...styles.image} src={offerringsUpdate.fields.image} altText={fields.title} />
                            </StyledWrapper>
                            <StyledWrapper {...styles.titleGridItem}>
                                <Typography as="p" {...styles.expertExperience}>
                                    {offerringsUpdate.fields.expertExperience}
                                </Typography>
                                <StyledWrapper {...styles.chatButtonWrapper}>
                                    <StyledWrapper as="a" href={`tel:${fields.contactNumber}`} {...styles.numberStyles}>
                                        {fields.contactNumber}
                                    </StyledWrapper>
                                </StyledWrapper>
                                <Typography as="p" {...styles.expertTime}>
                                    {offerringsUpdate.fields.expertTime}
                                </Typography>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CenCategoryLookingForExpert),
    definition: {
        group: "Common",
        displayName: "CEN Category Looking for Expert",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
            },
            {
                name: fields.changeImage,
                displayName: "After how many days image should change",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: fields.startDate,
                displayName: "Start date",
                defaultValue: null,
                editorTemplate: "DateTimeField",
                fieldType: "General",
            },
            {
                name: fields.contactNumber,
                displayName: "Contact Number",
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "General",
            },
            {
                name: fields.offerings,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },

                    {
                        name: "expertExperience",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "linkURL",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                    },
                    {
                        name: "expertTime",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
